import { COMMA, ENTER, SPACE } from '@angular/cdk/keycodes';
import { Component, Inject, OnInit } from '@angular/core';
import {
  UntypedFormArray,
  UntypedFormBuilder,
  UntypedFormGroup,
  Validators
} from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { IParceiroContato } from '@app/modules/parceiro/model';
import { Utils } from '@app/shared/helpers/utils';
import { CustomValidators } from 'viggo-sistemas-core-web';

@Component({
  selector: 'app-dialog-edit-contato',
  templateUrl: './dialog-edit-contato.component.html',
  styleUrls: ['./dialog-edit-contato.component.scss']
})
export class DialogEditContatoComponent implements OnInit {
  teclasSeparadoras = [ENTER, COMMA, SPACE];

  form: UntypedFormGroup;
  tagsBck: string | string[];
  formTag: UntypedFormArray;

  constructor(
    public dialog: MatDialogRef<DialogEditContatoComponent>,
    @Inject(MAT_DIALOG_DATA) public data: { contato: IParceiroContato },
    private fb: UntypedFormBuilder
  ) {}

  ngOnInit(): void {
    const { contato } = this.data;
    this.tagsBck = contato.tag;
    this.form = this.fb.group({
      contato: [
        contato.contato,
        [
          Validators.required,
          Validators.maxLength(100),
          CustomValidators.isEmptyValue()
        ]
      ]
    });
    this.form.markAsDirty();
    this.formTag = this.form.controls.tag as UntypedFormArray;
  }

  cancelar(): void {
    this.data.contato.tag = this.tagsBck;
    this.dialog.close(
      this.data.contato.contato === ''
        ? undefined
        : Utils.trimAttributes({ ...this.data.contato })
    );
  }
  salvar(): void {
    if (Array.isArray(this.data.contato.tag))
      this.data.contato.tag = this.data.contato.tag.join(' ');
    this.dialog.close(
      Utils.trimAttributes({ ...this.data.contato, ...this.form.value })
    );
  }

  /**
   * Salva as informações vindas do component de tag
   */
  onChangeTag(value): void {
    const { contato } = this.data;
    contato.tag = value;
  }
  //FIXME: TAGS DE SISTEMA
  // salvar(): void {
  //   if (Array.isArray(this.data.contato.tag))
  //     this.data.contato.tag = this.data.contato.tag.join(' ');
  //   if (this.tagsBck.length > this.data.contato.tag.length) {
  //     const prevValue = this.data.contato.tags;
  //     const index = this.data.contato.tags.findIndex(
  //       t => t.value === this.tagsBck
  //     );
  //     if (index >= 0) {
  //       prevValue.splice(index, 1);
  //       this.data.contato.tags = prevValue;
  //     }
  //   }

  //   this.dialog.close(
  //     Utils.trimAttributes({ ...this.data.contato, ...this.form.value })
  //   );
  // }

  /**
   * Salva as informações vindas do component de tag
   */
  // onChangeTag(value): void {
  //   const { contato } = this.data;
  //   contato.tag = value.map(t => t.value);
  //   contato.tags = value;
  // }
}
